import React from "react";
import PropTypes from "prop-types";
import keygen from '~helpers/keygen';
import styles from "./layout-section.module.scss";
import Redirect from "./link";

const LayoutSection = ({ menus }) => {
  const paths = (type, id) => {
    switch (type) {
      case "menu":
        return `site-menus/${id}/items`;
      case "page":
        return `site-pages/${id}`;
      case "operator":
        return `operators/${id.operator_id}/sites-data/edit/${id.id}`;
      case "game":
        return `games/${id.game_id}/sites?site_name=${process.env.GATSBY_SITE_NAME}`;
      case "author":
        return `site-authors/${id}`;
      case "payment_method":
        return `deposit-methods/${id.id}`;
      default:
        return "";
    }
  };

  return menus?.map((res) => (
    <li key={keygen()}>
      <span className={`${styles.menuItem} ${styles.link}`}>{res.label}</span>
      <div className={styles.subMenuList}>
        <div className={styles.subMenuContianer}>
          {res?.sections?.map((section) => (
            <ul key={keygen()} className={styles.lists}>
              {section.label && (
                <li key={keygen()}>
                  <span className={styles.label}>{section.label}</span>
                </li>
              )}
              {section?.links?.map((link) => (
                <li key={keygen()}>
                  <Redirect
                    icon={link?.icon}
                    path={paths(link?.type, link.data)}
                    linkText={link.buttonText}
                    description={link.description}
                  />
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    </li>
  ));
};

LayoutSection.propTypes = {
  navSection: PropTypes.shape({}),
  footerSection: PropTypes.shape({
    extra_fields: PropTypes.shape({}),
  }),
  menuObj: PropTypes.shape({
    menu_id: PropTypes.number,
  }),
};

export default LayoutSection;
